// extracted by mini-css-extract-plugin
export default {"page-not-found":"pageNotFount_page-not-found__Mffov"};